export default {
	"Verification.one": "壹",
	"Verification.two": "贰",
	"Verification.three": "叁",
	"Verification.shop": "肆",
	"Verification.five": "伍",
	"Verification.land": "陆",
	"Verification.Seven": "柒",
	"Verification.splitOpen": "捌",
	"Verification.Nine": "玖",
	"Verification.ParentVerification": "家长验证",
	"Verification.ClickInOrder": "请按顺序依次点击:"
}